// ENUM per la tipologia di azione
export enum SUB_ACTION {
  NONE = 'NONE',
  CHANGE_SUB_NAME = 'CHANGE_SUB_NAME',
  CHANGE_PUBLIC = 'CHANGE_PUBLIC',
  CHANGE_DOMAIN = 'CHANGE_DOMAIN',
  CHANGE_ADMIN = 'CHANGE_ADMIN',
  ADD_USER = 'ADD_USER',
  CHANGE_USER = 'CHANGE_USER',
  DELETE_USER = 'DELETE_USER',
  ADD_USER_ACCESS = 'ADD_USER_ACCESS',
  CHANGE_USER_ACCESS = 'CHANGE_USER_ACCESS',
  DELETE_USER_ACCESS = 'DELETE_USER_ACCESS',
  SET_CLAIRE = 'SET_CLAIRE',
  SET_CREDITS = 'SET_CREDITS',
  SEND_MAIL = 'SEND_MAIL',
}

export enum MAIL_TYPE {
  NONE = 'NONE',
  ACTIVATION = 'ACTIVATION',
  CLAIRE_ACTIVATE = 'CLAIRE_ACTIVATE',
  CLAIRE_DEACTIVATE = 'CLAIRE_DEACTIVATE',
  USER_ACTIVATE = 'USER_ACTIVATE',
  USER_DEACTIVATE = 'USER_DEACTIVATE',
  RENEW = 'RENEW',
}

export class BaseSubActionDto {
  action: SUB_ACTION = SUB_ACTION.NONE;
  payload: any = {};
}

export class ChangeSubNameDto extends BaseSubActionDto {
  constructor(name: string | undefined) {
    super();
    this.action = SUB_ACTION.CHANGE_SUB_NAME;
    this.payload = {
      name: name?.trim() || '',
    };
  }
}

export class ChangePublicDto extends BaseSubActionDto {
  constructor(_public: boolean | undefined) {
    super();
    this.action = SUB_ACTION.CHANGE_PUBLIC;
    this.payload = {
      public: _public || false,
    };
  }
}

export class ChangeDomainDto extends BaseSubActionDto {
  constructor(domain: string | undefined) {
    super();
    this.action = SUB_ACTION.CHANGE_DOMAIN;
    this.payload = {
      domain: domain?.trim() || '',
    };
  }
}

export class ChangeAdminDto extends BaseSubActionDto {
  constructor(email: string | undefined, name: string | undefined, notes: string | undefined) {
    super();
    this.action = SUB_ACTION.CHANGE_ADMIN;
    this.payload = {
      email: email?.trim().toLowerCase() || '',
      name: name?.trim() || '',
      notes: notes?.trim() || '',
    };
  }
}

export class AddUserDto extends BaseSubActionDto {
  constructor(email: string | undefined, name: string | undefined, notes: string | undefined) {
    super();
    this.action = SUB_ACTION.ADD_USER;
    this.payload = {
      email: email?.trim().toLowerCase() || '',
      name: name?.trim() || '',
      notes: notes?.trim() || '',
    };
  }
}

export class ChangeUserDto extends AddUserDto {
  constructor(email: string | undefined, name: string | undefined, notes: string | undefined) {
    super(email, name, notes);
    this.action = SUB_ACTION.CHANGE_USER;
  }
}

export class DeleteUserDto extends BaseSubActionDto {
  constructor(email: string | undefined) {
    super();
    this.action = SUB_ACTION.DELETE_USER;
    this.payload = {
      email: email?.trim().toLowerCase() || '',
    };
  }
}

export class AddUserAccessDto extends BaseSubActionDto {
  constructor(email: string | undefined, name: string | undefined, notes: string | undefined) {
    super();
    this.action = SUB_ACTION.ADD_USER_ACCESS;
    this.payload = {
      email: email?.trim().toLowerCase() || '',
      name: name?.trim() || '',
      notes: notes?.trim() || '',
    };
  }
}

export class ChangeUserAccessDto extends AddUserAccessDto {
  constructor(email: string | undefined, name: string | undefined, notes: string | undefined) {
    super(email, name, notes);
    this.action = SUB_ACTION.CHANGE_USER_ACCESS;
  }
}

export class DeleteUserAccessDto extends BaseSubActionDto {
  constructor(email: string | undefined) {
    super();
    this.action = SUB_ACTION.DELETE_USER_ACCESS;
    this.payload = {
      email: email?.trim().toLowerCase() || '',
    };
  }
}

export class SetClaireDto extends BaseSubActionDto {
  constructor(email: string | undefined, enabled: boolean) {
    super();
    this.action = SUB_ACTION.SET_CLAIRE;
    this.payload = {
      email: email?.trim().toLowerCase() || '',
      enabled: enabled,
    };
  }
}

export class SetCreditsDto extends BaseSubActionDto {
  constructor(email: string | undefined, credits: number) {
    super();
    this.action = SUB_ACTION.SET_CREDITS;
    this.payload = {
      email: email?.trim().toLowerCase() || '',
      credits: credits || 0,
    };
  }
}

export class SendMailDto extends BaseSubActionDto {
  constructor(mailTo: string | undefined, fullName: string | undefined, mailType: MAIL_TYPE) {
    super();
    this.action = SUB_ACTION.SEND_MAIL;
    this.payload = {
      mailTo: mailTo?.trim().toLowerCase() || '',
      fullName: fullName?.trim() || '',
      mailType: mailType || MAIL_TYPE.NONE,
    };
  }
}
